import React, { Component } from 'react';
import Select from 'react-select';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../utils/restApiHeaderUtils';
import { environmentSwitchOptions, PREVIEW } from '../utils/environments';
import { localStorageKey } from '../utils/constant';

class EnvironmentSelect extends Component {
  state = {
    environment: environmentSwitchOptions.find((option) => option.value === PREVIEW),
    envi: null,
    resultArray: [],
  };

  handleChange = (environment) => {
    localStorage.setItem(localStorageKey.ENVIRONMENT, environment.value);
    this.setState({ environment });
    if (this.props.refreshMethod) {
      this.props.refreshMethod();
    }
  };

  mappingArray() {
    if (this.state.envi) {
      const resultArray = environmentSwitchOptions.filter((option) =>
        this.state.envi.some((env) => env.envType === option.value),
      );
      return resultArray;
    }
    return [];
  }

  getDataOfProjectDetails = async () => {
    try {
      const { projectId } = { projectId: this.props.projectId };
      const { version } = { version: this.props.version };

      const header = builderSurfaceJsonContentHeader(projectId);
      const response = await axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/`,
        { headers: header },
      );
      const environments = response.data.environments;
      this.setState({ envi: environments }, () => {
        const resultArray = this.mappingArray();
        this.setState({ resultArray });
      });
    } catch (error) {
      console.error('Error fetching project details:', error);
    }
  };

  componentDidMount = async () => {
    let envStr = localStorage.getItem(localStorageKey.ENVIRONMENT);
    const environment = environmentSwitchOptions.find((envOption) => envOption.value === envStr);
    this.setState({ environment });
    envStr = envStr || PREVIEW;
    await this.getDataOfProjectDetails();
  };

  render() {
    const { resultArray, environment } = this.state;
    const colourStyles = {
      control: (styles) => ({ ...styles, backgroundColor: '#fff' }),
      option: (styles, { isDisabled, isFocused, isSelected }) => {
        return {
          ...styles,
          fontSize: '0.875rem',
          color: isDisabled ? null : isSelected ? 'white' : isFocused ? 'white' : null,
          backgroundColor: isDisabled
            ? null
            : isSelected
            ? '#1ba7ae'
            : isFocused
            ? '#1ba7ae9c'
            : null,
          ':active': {
            ...styles[':active'],
            backgroundColor: !isDisabled && (isSelected ? '#fff' : '#1ba7ae'),
          },
        };
      },
    };

    return (
      <Select
        name="environment"
        isMulti={false}
        className="custom-select-container"
        classNamePrefix="custom-select"
        options={resultArray}
        value={environment}
        onChange={this.handleChange}
        styles={colourStyles}
        getOptionLabel={(e) => (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {e.icon && <i className={`wb webconnect-${e.icon}`} style={{ lineHeight: '0' }}></i>}
            <span style={{ marginLeft: 5 }}>{e.label} Data</span>
          </div>
        )}
      />
    );
  }
}

export default EnvironmentSelect;
